<template>
  <mf-loading-dialog :loading="$apollo.loading">
    <base-page-layout ref="base-page" :title="$t('campanhas.resultados_campanha')" :hide-breadcrumbs="$getFirstValue()">
      <template v-slot:header>
        <div class="header-actions">
          <results-pdf
            :campaign="campanha"
            :offer-type="offerTypeComputed"
            :loading="$apollo.loading"
            :products="listAllProducts"
            :campaign-cards-metrics="resultsCardsMetrics"
            :unit-metrics="unitMetrics"
            :campaign-metrics-offer-type="campaignMetricsOfferType"
            :activatable="campanha.activatable"
          >
            <template v-slot:uplift>
              <uplift-data
                is-pdf-content
                :offer-type="offerTypeComputed"
                :products="offerTypeProducts"
                :loading="$apollo.loading"
                :metrics="campaignMetricsOfferType"
                :periods="periods"
                :units="offerScheduleCampaign.units"
              ></uplift-data>
            </template>
            <template v-slot:total-products-table>
              <total-products-results-table
                :metrics="campaignMetricsOfferType"
                :campaign-model="modelOfCampaign"
                :current-offer-type-key-name="currentOfferTypeKeyName"
              />
            </template>
            <template v-slot:products-table>
              <products-results-table
                :metrics="campaignMetricsOfferType"
                :campaign-model="modelOfCampaign"
                :current-offer-type-key-name="currentOfferTypeKeyName"
              />
            </template>
            <template v-slot:profile-table>
              <profile-results-table :metrics="campaignMetricsOfferType" :base-metric="modelOfCampaign" />
            </template>
          </results-pdf>
        </div>
      </template>
      <results-header :campaign="campanha" :offer-type="offerTypeComputed" :show-settings-button="!queryParamFranchise" />
      <v-row>
        <v-col>
          <mf-tabs-menu v-model="offersTypeTabHighLevel" :tabs="offersTypeTabsHighLevel" class="mt-4">
            <template v-slot:children>
              <mf-tabs-menu v-model="offersTypeTabLowLevel" :tabs="getSubTabTabs" class="mt-4" />
            </template>
          </mf-tabs-menu>
        </v-col>
      </v-row>

      <div class="px-5">
        <v-row>
          <v-col class="d-flex justify-end">
            <export-report-by-unit :franchise="queryParamFranchise" :offer-sales-type="currentOfferTypeKeyName" />
          </v-col>
        </v-row>

        <v-row>
          <v-col v-for="card in resultsCardsMetrics" :key="card.title" cols="3">
            <cbm-card
              :number-text="card.number"
              :title="card.title"
              :is-currency="card.isCurrency"
              :percent-text="card.percent"
              :percent-description="card.description"
              :boolean-loader="$apollo.loading"
              :tooltip="card.tooltipText"
              :percentage-tooltip="card.percentageTooltip"
              simple-card
              :unset-percentage-colors="!card.usePercentageColor"
              :number-color="card.numberColor ? card.numberColor : ''"
            >
              <template v-if="card.expires" #custom-additional-value>
                <p v-if="card.expires" class="mb-0 cashback-expiration">
                  Expiração: <b>{{ card.expires }}</b>
                </p>
              </template>
            </cbm-card>
          </v-col>
        </v-row>

        <v-row v-if="campanha.auto_distributed">
          <v-col>
            <campaign-impact-chart :campaign="campanha" :products="listAllProducts" :offer-type="currentOfferTypeKeyName" />
          </v-col>
        </v-row>
        <v-row v-if="campanha.auto_distributed">
          <v-col>
            <customers-types-funnel-graph :funil-metrics="campanha.clientMetrics" :campaign="campanha" :offer-type="currentOfferTypeKeyName" />
          </v-col>
        </v-row>

        <v-row v-if="isIndustry && isNextBuyCashbackCurrentOfferType">
          <v-col cols="8">
            <benefit-group-card :metrics="campaignMetricsOfferType" :loading="$apollo.loading" :offer-type="offerTypeComputed" />
          </v-col>
          <v-col cols="4">
            <benefit-progress-card :metrics="campaignMetricsOfferType" :loading="$apollo.loading" :offer-type="offerTypeComputed" />
          </v-col>
        </v-row>

        <uplift-data
          :offer-type="offerTypeComputed"
          :products="offerTypeProducts"
          :loading="$apollo.loading"
          :metrics="campaignMetricsOfferType"
          :periods="periods"
          :units="offerScheduleCampaign.units"
        ></uplift-data>

        <funnel-data
          :loading="$apollo.loading"
          :metrics="campaignMetricsOfferType"
          :unit-metrics="unitMetrics"
          :offer-type="offerTypeComputed"
          :activatable="campanha.activatable"
          show-expansion-button
        />

        <quantity-per-unit-chart v-if="!Boolean(this.campanha.industry)" :loading="$apollo.loading" :metrics="unitMetrics" :offer-type="offerTypeComputed" />

        <v-row>
          <v-col>
            <funnel
              :loading="$apollo.loading"
              :metrics="campaignMetricsOfferType"
              :base-metric="modelOfCampaign"
              :campaign="campanha"
              :hide-quick-action-from-franchisee="hideQuickActionFromFranchisee"
              :offer-type="currentOfferTypeKeyName"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <products-table
              :loading="$apollo.loading"
              :metrics="campaignMetricsOfferType"
              :offer-schedule="offerScheduleCampaign"
              :rebate-metrics="rebateMetrics"
              base-metric="sales"
              :campaign-model="modelOfCampaign"
              show-discounts
              :current-offer-type-key-name="currentOfferTypeKeyName"
              :hide-quick-action-from-franchisee="hideQuickActionFromFranchisee"
              :is-industry-campaign="isIndustry"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <products-table
              :loading="$apollo.loading"
              :metrics="campaignMetricsOfferType"
              :offer-schedule="offerScheduleCampaign"
              base-metric="sales"
              :campaign-model="modelOfCampaign"
              show-discounts
              :current-offer-type-key-name="currentOfferTypeKeyName"
              :hide-quick-action-from-franchisee="hideQuickActionFromFranchisee"
              :is-industry-campaign="isIndustry"
            />
          </v-col>
        </v-row>

        <mf-action-buttons
          v-if="!isFranchisee"
          :primary-button="{
            text: 'Duplicar',
            action: cloneOffer,
            isVisible: true,
            isDisabled: isIndustry,
            isLoading: loading.primaryButton,
          }"
          :cancel-button="{
            text: 'Fechar',
            action: backToOffersList,
            isVisible: true,
            isDisabled: false,
          }"
        />
        <mf-action-buttons
          v-else
          :primary-button="{
            text: 'Fechar',
            action: backToOffersList,
            isVisible: true,
            isDisabled: isIndustry,
            isLoading: loading.primaryButton,
          }"
        />
      </div>
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import ExportReportByUnit from '../components/ExportReportByUnit'
import ResultsHeader from '@/components/campaigns/ResultsHeader.vue'
import { QUERY_SALES_CAMPAIGN_RESULTS_BY_ID, MUTATION_CLONE_SALES_CAMPAIGN } from '../../graphql'
import { getOfferTypeName } from '@/modules/campanhas/gestao-ofertas-v2/helpers/offerType.js'
import { DateTime } from 'luxon'
import { assertArray, localeString, abbreviation } from '@/config/helpers.js'
import { mergeAllIndividualAndGroupProductsByOffer, mergeAllComboProducts } from '@/modules/campanhas/gestao-ofertas-v2/helpers/products.js'
import { offerSalesTabs } from '../mixins/offer-sales-tabs'
import CbmCard from '@/components/CbmCard.vue'
import UpliftData from '@/modules/campanhas/gestao-ofertas-v2/views/components/UpliftData.vue'
import FunnelData from '@/components/campaigns/FunnelData.vue'
import QuantityPerUnitChart from '@/components/campaigns/QuantityPerUnitChart.vue'
import { rebateTooltip } from '@/modules/industria/helpers/rebateHelper.js'
import ResultsPdf from '../components/pdf/ResultsPdf.vue'
import ProductsResultsTable from '../components/pdf/ProductsResultsTable.vue'
import ProfileResultsTable from '../components/pdf/ProfileResultsTable.vue'
import TotalProductsResultsTable from '../components/pdf/TotalProductsResultsTable.vue'
import CampaignImpactChart from '../components/CampaignImpactChart.vue'
import CustomersTypesFunnelGraph from '../components/CustomersTypesFunnelGraph.vue'

export default {
  name: 'Results',
  components: {
    BasePageLayout,
    CbmCard,
    ResultsPdf,
    UpliftData,
    FunnelData,
    ResultsHeader,
    QuantityPerUnitChart,
    ExportReportByUnit,
    ProfileResultsTable,
    ProductsResultsTable,
    TotalProductsResultsTable,
    Funnel: () => import('@/modules/campanhas/views/components/results/Funnel.vue'),
    ProductsTable: () => import('@/modules/campanhas/views/components/results/ProductsTable.vue'),
    BenefitGroupCard: () => import('@/modules/industria/ofertas-trade/views/components/BenefitGroupCard.vue'),
    BenefitProgressCard: () => import('@/modules/industria/ofertas-trade/views/components/BenefitProgressCard.vue'),
    CampaignImpactChart,
    CustomersTypesFunnelGraph,
  },
  mixins: [offerSalesTabs],
  data: () => ({
    locale: localeString,
    loading: {
      primaryButton: false,
    },
    render: true,
    campanha: {
      name: '',
      description: '',
      eans: [],
      start_date: '',
      end_date: '',
      offer_sales: [],
      active: false,
      segments: [],
      activatable: false,
      industry: null,
    },
    DateTime: DateTime,
    dateViewSegmentation: '2023-02-01',
    offerType: '',
  }),
  computed: {
    rebateMetrics() {
      return this.campanha?.rebate_metrics?.data?.[this.offerType]
    },

    queryParamFranchise() {
      return typeof this.$route.query.franchise === 'string' ? this.$route.query.franchise === 'true' : this.$route.query.franchise
    },
    modules() {
      return this.$getAllowedModules()
    },
    offerTypeComputed: {
      get() {
        return this.offerType
      },
      set(value) {
        this.offerType = value
      },
    },
    periods() {
      return {
        offered: {
          startDate: this.campanha?.start_date,
          endDate: this.campanha?.end_date,
        },
        previous: {
          startDate: this.campanha?.reference_period_metrics?.start_date,
          endDate: this.campanha?.reference_period_metrics?.end_date,
        },
      }
    },
    isIndustry() {
      return Boolean(this.campanha?.industry)
    },
    isFranchisee() {
      if (!this.$getLoggedUser().is_franchisee) return false
      return this.$getLoggedUser().is_franchisee
    },
    unitMetrics() {
      return this.campanha?.unit_metrics
    },
    hideQuickActionFromFranchisee() {
      return this.isFranchisee && this.queryParamFranchise
    },
    revenuePercentage() {
      return this.concatPercent(
        this.campaignMetricsOfferType?.clients_metrics?.total?.revenue
          ? abbreviation(
              (this.campaignMetricsOfferType?.clients_metrics?.with_sales?.revenue / this.campaignMetricsOfferType?.clients_metrics?.total?.revenue) * 100,
              { isCurrency: true }
            )
          : 0
      )
    },
    firstPurchasePercentage() {
      return this.concatPercent(
        this.campaignMetricsOfferType?.first_purchase_metrics?.count_total
          ? localeString(
              this.campaignMetricsOfferType?.first_purchase_metrics?.count_total
                ? (this.campaignMetricsOfferType?.first_purchase_metrics?.count_with_sales /
                    this.campaignMetricsOfferType?.first_purchase_metrics?.count_total) *
                    100
                : 0,
              2
            )
          : 0
      )
    },
    ticketPercentage() {
      return this.concatPercent(
        this.concatSum(
          this.campaignMetricsOfferType?.clients_metrics?.with_sales?.average_ticket
            ? localeString(
                this.campaignMetricsOfferType?.clients_metrics?.with_sales?.average_ticket
                  ? (this.campaignMetricsOfferType?.clients_metrics?.with_sales?.average_ticket /
                      this.campaignMetricsOfferType?.clients_metrics?.total?.average_ticket -
                      1) *
                      100
                  : 0,
                2
              )
            : 0
        )
      )
    },
    resultsCardsMetrics() {
      return [
        {
          title: 'Faturamento',
          isCurrency: true,
          number: localeString(this.campaignMetricsOfferType?.clients_metrics?.with_sales?.revenue || 0, 0),
          percent: this.revenuePercentage,
          description: 'do faturamento total',
          tooltipText: 'Faturamento dos cupons com produtos em oferta.',
          percentageTooltip: `Faturamento total no período ofertado: R$${
            this.campaignMetricsOfferType?.clients_metrics?.total?.revenue ? localeString(this.campaignMetricsOfferType?.clients_metrics?.total?.revenue, 2) : 0
          }`,
          usePercentageColor: false,
        },
        {
          title: this.offerCardLabel,
          isCurrency: this.offerType !== 'points',
          number: this.offerCardValue,
          percent: '',
          description: this.isIndustry ? 'a ser pago pela indústria' : '',
          tooltipText: this.offerCardTooltip,
          percentageTooltip: '',
          usePercentageColor: false,
          numberColor: this.isIndustry ? '#0A8533' : '',
          expires: this.isCashbackCurrentOfferType && !this.isIndustry ? this.getCashbackExpiration : '',
        },
        {
          title: 'Primeiras compras',
          isCurrency: false,
          number: localeString(this.campaignMetricsOfferType?.first_purchase_metrics?.count_with_sales || 0, 0),
          percent: this.firstPurchasePercentage,
          description: 'do total de primeiras compras',
          tooltipText: 'Total de consumidores que compraram algum desses produtos pela primeira vez dentro da mensuração da campanha.',
          percentageTooltip: '',
          usePercentageColor: false,
        },
        {
          title: 'Ticket médio',
          isCurrency: true,
          number: localeString(this.campaignMetricsOfferType?.clients_metrics?.with_sales?.average_ticket || 0, 2),
          percent: this.ticketPercentage,
          description: 'do ticket médio geral',
          tooltipText: 'Ticket médio dos cupons com algum produto da oferta.',
          percentageTooltip: `Ticket médio geral: R$${
            this.campaignMetricsOfferType?.clients_metrics?.total?.average_ticket
              ? localeString(this.campaignMetricsOfferType?.clients_metrics?.total?.average_ticket, 1)
              : 0
          }`,
          usePercentageColor: true,
        },
      ]
    },
    offerTypeProducts() {
      if (!this.offerTypeResultsCurrentTabDetails?.keyName) {
        return []
      }
      if (this.offerTypeResultsCurrentTabDetails?.keyName === 'combo_offer_sales') {
        return assertArray(this.campanha.combo_offer_sales).reduce((productList, product) => {
          productList.push(...mergeAllComboProducts(product.target_products, 'target_products'))
          productList.push(...mergeAllComboProducts(product.trigger_products, 'trigger_products'))
          return productList
        }, [])
      }
      return mergeAllIndividualAndGroupProductsByOffer(
        this.campanha[this.offerTypeResultsCurrentTabDetails?.keyName],
        this.offerTypeResultsCurrentTabDetails?.keyName
      )
    },
    listAllProducts() {
      const offerSalesProducts = mergeAllIndividualAndGroupProductsByOffer(this.campanha.offer_sales, 'offer_sales')
      const percentageOfferSalesProducts = mergeAllIndividualAndGroupProductsByOffer(this.campanha.percentage_offer_sales, 'percentage_offer_sales')
      const dynamicPricingPercentageOfferSalesProducts = mergeAllIndividualAndGroupProductsByOffer(
        this.campanha.dynamic_pricing_percentage_offer_sales,
        'dynamic_pricing_percentage_offer_sales'
      )
      const takeAndPayOfferSalesProducts = mergeAllIndividualAndGroupProductsByOffer(this.campanha.takepay_offer_sales, 'takepay_offer_sales')
      const cashbackPercentageOfferSalesProducts = mergeAllIndividualAndGroupProductsByOffer(
        this.campanha.cashback_percentage_offer_sales,
        'cashback_percentage_offer_sales'
      )
      const cashbackAbsoluteOfferSalesProducts = mergeAllIndividualAndGroupProductsByOffer(
        this.campanha.cashback_absolute_offer_sales,
        'cashback_absolute_offer_sales'
      )
      const pointsOfferSalesProducts = mergeAllIndividualAndGroupProductsByOffer(this.campanha.points_offer_sales, 'points_offer_sales')

      const comboOfferSalesProducts = assertArray(this.campanha.combo_offer_sales).reduce((productList, product) => {
        productList.push(...mergeAllComboProducts(product.target_products, 'target_products'))
        productList.push(...mergeAllComboProducts(product.trigger_products, 'trigger_products'))

        return productList
      }, [])

      return [
        ...offerSalesProducts,
        ...percentageOfferSalesProducts,
        ...dynamicPricingPercentageOfferSalesProducts,
        ...takeAndPayOfferSalesProducts,
        ...comboOfferSalesProducts,
        ...cashbackPercentageOfferSalesProducts,
        ...cashbackAbsoluteOfferSalesProducts,
        ...pointsOfferSalesProducts,
      ]
    },
    modelOfCampaign() {
      return this.campanha.activatable ? 'activatable' : 'sales'
    },
    offerCardLabel() {
      if (this.isIndustry) {
        return 'Reembolso'
      }
      if (this.isCashbackOrPointsCurrentOfferType) {
        if (this.isCashbackCurrentOfferType) return 'Cashback distribuído'
        else return 'Pontos distribuídos'
      }
      return 'Desconto'
    },
    offerCardValue() {
      if (this.isIndustry) {
        return localeString(this.rebateMetricsOfferType?.rebate, 2)
      }
      if (this.isCashbackOrPointsCurrentOfferType) {
        if (this.isCashbackCurrentOfferType) return localeString(this.campaignMetricsOfferType?.products_metrics?.totals.sales?.cashback || 0, 0)
        else return localeString(this.campaignMetricsOfferType?.products_metrics?.totals.sales?.points || 0, 0)
      }
      return localeString(this.campaignMetricsOfferType?.products_metrics?.totals.sales?.discounts || 0, 0)
    },
    offerCardTooltip() {
      if (this.isIndustry) {
        return rebateTooltip(this.offerType)
      }
      if (this.isCashbackOrPointsCurrentOfferType) {
        if (this.isCashbackCurrentOfferType) return 'Total de cashback distribuído pelos produtos dessa campanha'
        else return 'Total de pontos e pontos extras distribuídos pelos produtos dessa campanha'
      }
      return 'Total de descontos concedidos através dos produtos vendidos na campanha'
    },
    rebateMetricsOfferType() {
      return this.campanha?.rebate_metrics?.data?.[getOfferTypeName(this.offerTypeResultsCurrentTabDetails?.keyName)]
    },
    campaignMetricsOfferType() {
      return this.campanha?.campaignMetrics?.[getOfferTypeName(this.offerTypeResultsCurrentTabDetails?.keyName)]
    },
    offerScheduleCampaign() {
      return {
        _id: this.campanha._id,
        name: this.campanha.name,
        units: this.campanha.units,
      }
    },
    campaignCreatedBeforeViewSegmentation() {
      if (this.campanha.created_at) {
        return DateTime.fromISO(this.campanha.created_at).startOf('day') <= DateTime.fromISO(this.dateViewSegmentation).startOf('day')
      }

      return false
    },

    viewSegmentationDate() {
      return DateTime.fromISO(this.dateViewSegmentation).toFormat('dd/MM/yyyy')
    },

    getCashbackExpiration() {
      if (this.campanha.expiration_cashback) {
        if (this.campanha.expiration_cashback.type === 'AT_PURCHASE') {
          const isNotSingleValue = this.campanha.expiration_cashback.expiration_in_days > 1
          return `${this.campanha.expiration_cashback.expiration_in_days} dia${isNotSingleValue && 's'} após a obtenção.`
        } else if (this.campanha.expiration_cashback.type === 'BY_DATE') {
          const expireDate = this.campanha.expiration_cashback.expires_at
          return DateTime.fromISO(expireDate).isValid
            ? DateTime.fromFormat(expireDate, 'yyyy-MM-dd').toFormat('dd/MM/yyyy')
            : DateTime.fromFormat(expireDate, 'yyyy-MM-dd HH:mm:ss').toFormat('dd/MM/yyyy')
        } else return ''
      } else return ''
    },
  },
  apollo: {
    campanha: {
      query: QUERY_SALES_CAMPAIGN_RESULTS_BY_ID,
      variables() {
        const { id } = this.$route.params
        const franchise = this.queryParamFranchise
        const data = { id }
        if (franchise) {
          data.franchise = franchise
        }
        return data
      },
      context() {
        return {
          uri: this.$microservicesUrls['sales'],
        }
      },
      update({ offerSchedule }) {
        return offerSchedule
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
    },
  },
  watch: {
    offersTypeTabLowLevel: {
      handler(newValue) {
        this.offerTypeComputed = getOfferTypeName(this.getSubTabTabs?.[newValue]?.keyName)
      },
      deep: true,
    },
    campanha: {
      handler(newValue) {
        if (!this.offerTypeComputed) {
          this.offerTypeComputed = getOfferTypeName(newValue?.types[this.offersTypeTabLowLevel])
        }
      },
      deep: true,
    },
  },
  methods: {
    concatSum(value) {
      const numberValue = typeof value === 'string' ? Number(value.replace(',', '.')) : value
      return numberValue > 0 ? '+' + value : value
    },
    concatPercent(value) {
      return value + '%'
    },
    getCashbackOrPointsIndex(offerType) {
      return this.cashbackAndPointsModulesActive.findIndex((offerSaleType) => offerSaleType === offerType)
    },
    redirectToSettings(path) {
      this.$router.push(path).catch(() => {})
    },
    async cloneOffer() {
      const confirmed = await this.$confirm({
        ...this.$t('campanhas.confirmations.clone'),
        message: 'Deseja duplicar esta campanha?',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return

      this.loading.primaryButton = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_CLONE_SALES_CAMPAIGN,
          variables: {
            id: this.campanha._id,
          },
          context: {
            uri: this.$microservicesUrls['sales'],
          },
        })
        .then(() => {
          this.backToOffersList()
        })
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.clone'))
        })
      this.loading.primaryButton = false
    },

    backToOffersList() {
      let routeName = 'gestao-ofertas'
      if (this.isIndustry) {
        routeName = 'ofertas-trade-historico'
      }
      this.$router.push({ name: routeName }).catch(() => {})
    },

    goToSegmentation(index) {
      if (!this.campanha.has_segment_data) {
        this.$snackbar({ message: 'Não é possível visualizar critérios desta campanha', snackbarColor: 'error' })
        return
      }

      const segment = this.campanha.segments[index]

      if (!segment) return

      const routeData = this.$router.resolve({
        name: 'visualizar-segmentacao',
        params: {
          campaignId: this.campanha._id,
          segmentId: segment._id,
        },
      })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>

<style lang="scss">
.alert-color {
  background-color: #fff9e3 !important;
  margin-bottom: 0;
}

.text-cinza-d10 {
  color: $cinza-d10;
}

.offer-settings-button {
  padding: 10px 24px !important;
  border-radius: 6px;
  border-color: $marca-0-l10 !important;
  height: 38px !important;
  .v-btn__content {
    color: $marca-0-l10;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.01em;
  }
}
.cashback-expiration {
  font-size: 14px;
  color: $cinza-0;

  b {
    color: $cinza-d10;
  }
}
</style>
